/* Ahead to Wellness theme JS — ported from the prototype's main.js.
   Depends on gsap, ScrollTrigger, Lenis loaded as globals (deferred, same order). */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- header state ---------- */
  var header = document.querySelector('.site-header');
  var onScroll = function () {
    if (header) header.classList.toggle('scrolled', window.scrollY > 8);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  /* the video hero pulls itself up under the sticky header by this much */
  var setHeaderH = function () {
    if (header) document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
  };
  setHeaderH();
  window.addEventListener('resize', setHeaderH, { passive: true });
  /* the header's height changes after first paint (web-font swap, wrapping logo line on phones),
     so re-measure whenever it resizes, not only when the window does */
  if (header && 'ResizeObserver' in window) new ResizeObserver(setHeaderH).observe(header);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(setHeaderH);

  /* ---------- booking links open in a new tab (keep visitors on the site) ---------- */
  document.querySelectorAll('a[href*="practicebetter.io"]').forEach(function (a) {
    a.target = '_blank';
    a.rel = 'noopener';
  });

  /* ---------- mobile menu ---------- */
  var toggle = document.querySelector('.nav-toggle');
  var menu = document.querySelector('.mobile-menu');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.body.style.overflow = open ? '' : 'hidden';
    });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        toggle.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
        document.body.style.overflow = '';
      });
    });
  }

  /* ---------- cart: SP terms gate ---------- */
  var gate = document.querySelector('[data-sp-terms-gate] input[type="checkbox"]');
  var checkoutBtn = document.querySelector('[data-checkout-button]');
  if (gate && checkoutBtn) {
    var syncGate = function () {
      if (gate.checked) {
        checkoutBtn.removeAttribute('disabled');
        checkoutBtn.removeAttribute('aria-disabled');
      } else {
        checkoutBtn.setAttribute('disabled', 'disabled');
        checkoutBtn.setAttribute('aria-disabled', 'true');
      }
    };
    gate.addEventListener('change', syncGate);
    syncGate();
  }

  /* ---------- shop sort: apply on change (the noscript button covers the rest) ---------- */
  document.querySelectorAll('form[data-auto-submit] select').forEach(function (sel) {
    sel.addEventListener('change', function () {
      sel.form.submit();
    });
  });

  /* ---------- motion (skipped entirely under reduced motion or missing libs) ---------- */
  if (reduced || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    document.documentElement.classList.add('reduced-motion');
    document.querySelectorAll('video[autoplay]').forEach(function (v) {
      if (reduced) {
        v.removeAttribute('autoplay');
        v.pause();
      }
    });
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  if (typeof Lenis !== 'undefined') {
    var lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis; // QA hook
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (time) {
      lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);

    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (id.length > 1 && document.querySelector(id)) {
          e.preventDefault();
          lenis.scrollTo(id, { offset: -72 });
        }
      });
    });
  }

  var ease = 'power3.out';

  /* ---------- reveals ---------- */
  document.querySelectorAll('[data-reveal]').forEach(function (el) {
    gsap.to(el, {
      opacity: 1,
      x: 0,
      y: 0,
      duration: 0.9,
      ease: ease,
      scrollTrigger: { trigger: el, start: 'top 88%' },
    });
  });

  document.querySelectorAll('[data-reveal-group]').forEach(function (group) {
    gsap.to(group.children, {
      opacity: 1,
      y: 0,
      duration: 0.85,
      ease: ease,
      stagger: 0.12,
      scrollTrigger: { trigger: group, start: 'top 85%' },
    });
  });

  /* ---------- hero entrance ---------- */
  if (document.querySelector('.hero')) {
    gsap
      .timeline({ defaults: { ease: ease, duration: 1 } })
      .to('.hero .eyebrow', { opacity: 1, y: 0, duration: 0.7 }, 0.05)
      .to('.hero-title .line', { opacity: 1, y: 0, stagger: 0.14 }, 0.15)
      .to('.hero-sub', { opacity: 1, y: 0 }, 0.55)
      .to('.hero-ctas', { opacity: 1, y: 0 }, 0.7)
      .to('.trust-row', { opacity: 1, y: 0, duration: 0.7 }, 0.85);
  }

  /* ---------- ridgeline draw ---------- */
  var ridge = document.querySelector('.ridge-path');
  if (ridge) {
    var len = ridge.getTotalLength();
    gsap.set(ridge, { strokeDasharray: len, strokeDashoffset: len });
    gsap.to(ridge, {
      strokeDashoffset: 0,
      duration: 2.4,
      ease: 'power2.inOut',
      delay: 0.5,
    });
  }

  /* ---------- hero frame expansion ---------- */
  var expandFrame = document.querySelector('[data-hero-expand]');
  if (expandFrame) {
    var mediaSection = expandFrame.closest('.hero-media');
    var heroMedia = expandFrame.querySelector('video, img');
    gsap
      .timeline({
        scrollTrigger: {
          trigger: mediaSection,
          start: 'top 92%',
          end: 'top 22%',
          scrub: 0.6,
        },
      })
      .to(mediaSection, { paddingLeft: 0, paddingRight: 0, ease: 'none' }, 0)
      .to(expandFrame, { borderRadius: 0, ease: 'none' }, 0)
      .fromTo(heroMedia, { scale: 1.08 }, { scale: 1, ease: 'none' }, 0);
  }

  /* ---------- parallax media ---------- */
  document.querySelectorAll('[data-parallax] img').forEach(function (img) {
    gsap.fromTo(
      img,
      { yPercent: -6 },
      {
        yPercent: 6,
        ease: 'none',
        scrollTrigger: {
          trigger: img.closest('[data-parallax]'),
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      }
    );
  });

  /* ---------- data figures ---------- */
  document.querySelectorAll('[data-fig]').forEach(function (fig) {
    var tl = gsap.timeline({
      scrollTrigger: { trigger: fig, start: 'top 78%' },
    });
    fig.querySelectorAll('.f-draw').forEach(function (p, i) {
      if (typeof p.getTotalLength !== 'function') return; // groups carry the class for styling only
      var l = p.getTotalLength();
      gsap.set(p, { strokeDasharray: l, strokeDashoffset: l });
      tl.to(p, { strokeDashoffset: 0, duration: 1.1, ease: 'power2.inOut' }, i * 0.18);
    });
    var grows = fig.querySelectorAll('.f-grow');
    if (grows.length) {
      tl.fromTo(
        grows,
        { scaleX: 0, transformOrigin: 'left center' },
        { scaleX: 1, duration: 0.8, ease: 'power3.inOut', stagger: 0.14 },
        0.15
      );
    }
    var pops = fig.querySelectorAll('.f-pop');
    if (pops.length) {
      tl.fromTo(
        pops,
        { opacity: 0, scale: 0.4, transformOrigin: 'center center' },
        { opacity: 1, scale: 1, duration: 0.5, ease: 'back.out(2)', stagger: 0.14 },
        0.55
      );
    }
    var fades = fig.querySelectorAll('.f-fade');
    if (fades.length) {
      tl.fromTo(fades, { opacity: 0 }, { opacity: 1, duration: 0.6, stagger: 0.09 }, 0.6);
    }
  });

  /* ---------- journey rail (draws as the steps scroll past) ---------- */
  var railPath = document.querySelector('.journey-path');
  if (railPath) {
    var railLen = railPath.getTotalLength();
    gsap.set(railPath, { strokeDasharray: railLen, strokeDashoffset: railLen });
    gsap.to(railPath, {
      strokeDashoffset: 0,
      ease: 'none',
      scrollTrigger: {
        trigger: '.journey-wrap',
        start: 'top 78%',
        end: 'bottom 60%',
        scrub: 0.5,
      },
    });
  }

  /* ---------- stat counters ---------- */
  document.querySelectorAll('.stat-n[data-count], .fig-count[data-count]').forEach(function (el) {
    var target = Number(el.dataset.count);
    var suffix = el.dataset.suffix || '';
    var obj = { v: 0 };
    gsap.to(obj, {
      v: target,
      duration: 1.6,
      ease: 'power2.out',
      scrollTrigger: { trigger: el, start: 'top 88%' },
      onUpdate: function () {
        el.textContent = Math.round(obj.v) + suffix;
      },
    });
  });
})();
